export default "__VITE_ASSET__nRq6fMCp__"